import React from 'react';
import {Trans} from 'react-i18next';
import {useSelector} from 'react-redux';
import subscriptionUtils from '../../../utils/subscriptionUtils';
import frontendUtils from '../../../utils/frontendUtils';
import subscriptionItemUtils from '../../../utils/subscriptionItemUtils';
import {solutionUtils} from '../../../utils/solutionUtils';

export default function Subscription() {
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const isTrial = subscriptionUtils.isTrialPlan(accountSummary);
  const isMultipleSolutions = solutionUtils.isMultipleSolutions(accountSummary);
  if (!isTrial || isMultipleSolutions) {
    return false;
  }

  const count = subscriptionUtils.getLeftDays(accountSummary);
  const customerId =
    (accountSummary && accountSummary.customer && accountSummary.customer.id) ||
    '';
  const {subscriptionItem} = accountSummary;
  const solutionType = subscriptionItemUtils.getSolutionType(subscriptionItem);
  const handlePurchaseNow = () => {
    window.open(
      frontendUtils.getPlanPriceUrl(
        'days-left-on-header',
        customerId,
        solutionType
      ),
      '_target'
    );
  };

  return (
    <div className="kt-header__topbar-item">
      <div className="kt-header__topbar-wrapper">
        <span
          className="btn btn-danger pf-header-text"
          onClick={() => handlePurchaseNow()}
        >
          {count < 0 ? (
            <Trans i18nKey="p.home.plan.trial.days.expired">
              Free Trial Expired
            </Trans>
          ) : (
            <Trans i18nKey="p.home.plan.trial.days.left" count={count}>
              {{count}} days left in trial
            </Trans>
          )}
        </span>
      </div>
    </div>
  );
}
